import { DOCUMENT, inject, Injectable } from '@angular/core';
import { UserContextService } from '../../context/user.context.service';
import { ENV_CONFIG } from '../../injection-tokens/environment.token';
import { EnvironmentConfig } from '../../model/environment.model';
import { WhoAmI } from '../../model/user/whoAmI.model';
import { AuthorityUtil } from '../../util/authority.util';
import { CommonUtil } from '../../util/common.util';
import { writeAuthCookie } from '../../util/auth-cookie.util';

/** Query key RDS uses for trusted portal return origin (not the session token). */
export const RISK_DASHBOARD_RETURN_ORIGIN_QUERY = 'returnOrigin';
export const AUTH_REDIRECT_OVERLAY_CLASS = 'vc-loader--auth-redirect';
export const AUTH_REDIRECT_FADE_MS = 150;

@Injectable({
    providedIn: 'root',
})
export class RiskDashboardCtaService {
    private readonly _document: Document = inject(DOCUMENT);
    private readonly _environment: EnvironmentConfig = inject(ENV_CONFIG);
    private readonly _userContextService: UserContextService = inject(UserContextService);
    private readonly _window: Window | null = this._document.defaultView;

    isVisible(user: WhoAmI | null): boolean {
        return (
            !!user?.hasAuthority(AuthorityUtil.PERMISSION_VCP_CORE_USER) &&
            !!user?.hasAuthority(AuthorityUtil.PERMISSION_MSS_NEW_EXPERIENCE)
        );
    }

    openNewExperience(): void {
        const token = this._userContextService.getTokenFromStorage();
        const baseUrl = this._environment.riskDashboardBaseUrl;
        if (!token || !baseUrl || !this._window) {
            return;
        }

        writeAuthCookie(this._document, token);

        const url = new URL(baseUrl);
        url.searchParams.set(RISK_DASHBOARD_RETURN_ORIGIN_QUERY, this._window.location.origin);
        this._document.getElementById('vc-page-loader')?.classList.add(AUTH_REDIRECT_OVERLAY_CLASS);
        CommonUtil.showAppLoader();
        this._window.setTimeout(() => this._window?.location.assign(url.toString()), AUTH_REDIRECT_FADE_MS);
    }
}
